import { jsx as _jsx } from "react/jsx-runtime";

const SectionLink = _ref => {
  let {
    text,
    url,
    testId
  } = _ref;
  return /*#__PURE__*/_jsx("li", {
    className: "main-footer__privacy-section-item",
    children: /*#__PURE__*/_jsx("a", {
      className: "main-footer__privacy-section-link",
      href: url,
      "data-testid": testId,
      children: text
    })
  });
};

export default SectionLink;